import { EntityField } from '~/jobiqo/models/entity';
import { EntityFieldRules } from '~/jobiqo/models/config';

export const AdditionalFieldItemWidgetsSlot = (
  field: EntityField,
  fieldRules: EntityFieldRules = {},
) => {
  switch (field.type) {
    default:
      return null;
  }
};

export default AdditionalFieldItemWidgetsSlot;
